export default {
  header: 'Dodaj test oceniający',
  description: 'Wybierz rodzaj oceny, którą chcesz Dodaj, klikając jeden z przycisków.',
  createTable: 'Tabela',
  createChart: 'Wykres',
  createImage: 'Obraz',
  createFile: 'Plik',
};
